export default "__VITE_ASSET__AlBVkDEy__"